import { render, staticRenderFns } from "./InputSrMenubar.vue?vue&type=template&id=34c8121a&scoped=true"
import script from "./InputSrMenubar.vue?vue&type=script&lang=js"
export * from "./InputSrMenubar.vue?vue&type=script&lang=js"
import style0 from "./InputSrMenubar.vue?vue&type=style&index=0&id=34c8121a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c8121a",
  null
  
)

export default component.exports